import { loadStripe } from '@stripe/stripe-js';

// Initialize Stripe with your publishable key
// Replace with your actual test publishable key
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || 'pk_test_51RbuAtB0gmcvoEBQnuFGCICbb7CHoXI2x3nQ2Xz4BuOE4kgIeVqD4oT70i1zP8choMp1iPMlOAlujxK00bVqGP9L00DUow14iE');

// Price IDs - replace these with your actual Stripe price IDs
export const STRIPE_PRICE_IDS = {
  monthly: 'price_1RfBLsB0gmcvoEBQSci4EiSm', // Replace with your monthly price ID
  yearly: 'price_1RfBMmB0gmcvoEBQalahAatm'    // Replace with your yearly price ID
};

export default stripePromise; 